module.exports = __webpack_public_path__ + "img/joszaki-head.49ca468.svg";